/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

export const TopBarTextField = styled(TextField)(() => ({
  width: 'auto',
  textTransform: 'uppercase',
  '& .MuiOutlinedInput-input': {
    fontSize: '13px',
    fontWeight: 500,
  },
  '& .MuiInputBase-adornedStart': {
    paddingLeft: 8,
  },
  '& .MuiSelect-iconOutlined': {
    position: 'unset',
    marginRight: '7px',
    marginLeft: '-8px',
  },
  '& .MuiInputBase-inputAdornedStart': {
    padding: '4px 33px 4px 17px!important',
    margin: '0px -18px 0px -19px',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#F5F5F5!important',
  },
  '& .MuiOutlinedInput-root:hover': {
    backgroundColor: '#E0E0E0!important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'unset',
  },
}));

export default TopBarTextField;
